import React, {useState} from 'react';
import {Modal, ModalBody, ModalHeader, ModalFooter, Button} from 'reactstrap';
import {deleteEntity} from 'utils/api';
import {toast} from 'react-toastify';
import SpinnerButton from 'components/SpinnerButton';
import {connect} from 'react-redux';

const DeleteConfirmModal = ({activeEntity, isOpen, toggle, refreshEntities, auth}) => {
    const [deleting, setDeleting] = useState(false);

    const onConfirm = async() => {
        try {
            setDeleting(true);
            await deleteEntity(activeEntity.id);
            await refreshEntities(true);
            setDeleting(false);
            toast.success('Entity successfully deleted');
            toggle();
        } catch(err) {
            setDeleting(false);
            if(err.message && err.message.length < 150) {
                toast.error(err.message);
            }
            console.log(err);
            throw err;
        }
    };

    return (
        <Modal isOpen={isOpen} toggle={toggle}>
            <ModalHeader toggle={toggle}>
                <strong>Are you sure you want to
                    delete {activeEntity.title ? activeEntity.title : 'this entity'}?</strong>
            </ModalHeader>
            <ModalBody>
                <div style={{paddingRight: 25}}>
                    All associated data will be deleted. This action is irreversible.
                </div>
            </ModalBody>
            <ModalFooter className="select-fetches-modal-footer">
                <Button style={{color: 'white'}} onClick={toggle}>
                    Cancel
                </Button>
                <SpinnerButton
                    style={{minWidth: '83.64px'}}
                    onClick={onConfirm}
                    submitting={deleting}
                    className="btn calltoaction-button"
                    title="Delete"
                />
            </ModalFooter>
        </Modal>
    );
};

// export default DeleteConfirmModal;

const mapStateFromProps = ({auth}) => ({
    auth,
});

export default connect(mapStateFromProps, null)(DeleteConfirmModal);